import { useLocation } from 'react-router';

export const useGuildPagesVisibility = () => {
  const location = useLocation();
  const roster = /roster/g.test(location.pathname);
  const mythicPlus = /mythic-plus-characters/g.test(location.pathname);
  const raidAchievements = /achievements/g.test(location.pathname);
  const raidEncounters = /raid-encounters/g.test(location.pathname);
  const stats = /stats/g.test(location.pathname);
  const recruitment = /recruitment/g.test(location.pathname);
  const profile = !roster && !mythicPlus && !raidAchievements && !raidEncounters && !stats && !recruitment;

  return {
    profile,
    roster,
    mythicPlus,
    raidAchievements,
    raidEncounters,
    stats,
    recruitment
  };
};

